export const validateEmail = (email: string): boolean => {
  // simplest thing that looks like an email address
  const re = /^[^@\s]+@[^@\s]+\.[^@\s]+$/i
  return re.test(String(email).toLowerCase())
}
